import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Form, Button, Input, Select, TreeSelect, Table, Row, Col, InputNumber, DatePicker, Space, Checkbox, message, Modal, Upload } from 'antd'
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons'
import { axiosHandleEvent, baseAxiosNoInfo } from '../../../tool/axios'
import { apiPrefix } from '../../../js/config'
import { ngetBase64 } from '../../../js/globalParam'
import _ from 'lodash'

import zfb from '../../../images/zfb.png'
import wx from '../../../images/wx.png'
import money from '../../../images/money.png'
import pos from '../../../images/pos.png'

const { Column } = Table
const { Option } = Select

const formItemLayout = {
    labelCol: { span: 3 },
    wrapperCol: { span: 12 }
}

export default function CkAddList() {

    let { id }: { id: string } = useParams()
    const [userData, setUserData] = useState<any>({ customer_name: '', customer_id: '' })

    const [formRef] = Form.useForm()
    const [formInfoRef] = Form.useForm()
    const [vipInfoRef] = Form.useForm()

    const [shouldPay, setShouldPay] = useState<number>()
    const [payNums, setPayNums] = useState<any>({ 1: undefined, 2: undefined, 3: undefined, 4: undefined })

    const [buyList, setBuyList] = useState<any[]>([])
    const [giveList, setGiveList] = useState<any[]>([])
    const [extraList, setExtraList] = useState<any[]>([])

    const [optionData, setOptionData] = useState<any[]>([])
    const [defaultStoreName, setDefaultStoreName] = useState<any[]>([])

    const [storeId, setStoreId] = useState<string>('')
    const [employeeIdAdviser, setEmployeeIdAdviser] = useState<string>('')
    const [employeeIdRecover, setEmployeeIdRecover] = useState<string>('')

    const [ckType, setCkType] = useState<any[]>([])
    const [ckTypeItem, setCkTypeItem] = useState<any[]>([])

    const [ckSingle, setCkSingle] = useState<any[]>([])
    const [ckMenu, setCkMenu] = useState<any[]>([])
    const [totalPrices, setTotalPrices] = useState<number>(0)
    const [payList, setPayList] = useState<any[]>([])

    const [packageItemData, setPackageItemData] = useState<any[]>([])
    const [packageItemVisible, setPackageItemVisible] = useState<boolean>(false)

    const [previewImage, setPreviewImage] = useState<string>('')
    const [visible, setVisible] = useState<boolean>(false)

    const handlePreview = async (file: any) => {
        if (!file.url && !file.preview) {
            file.preview = await ngetBase64(file.originFileObj);

        } else {
            file.preview = file.url;
        }

        setPreviewImage(file.preview)
        setVisible(true)
    }

    const uploadFile = (e: { fileList: [] }) => {
        if (Array.isArray(e)) {
            return e
        }

        return e && e.fileList
    }

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
        </div>
    )

    useEffect(() => {
        // 查询客户基础信息
        baseAxiosNoInfo.get('/chankang_center/customer/baseInfoDetail', { params: { customer_id: id } }).then((res: any) => {
            if (res) {
                setUserData([res])
            }
        })
    }, [])

    useEffect(() => {
        if (formInfoRef.getFieldValue('pay_way') && formInfoRef.getFieldValue('pay_way').length > 0) {
            let num = 0

            formInfoRef.getFieldValue('pay_way').forEach((el: any) => {
                num += ((Number(payNums[el]) * 100) / 100) || 0
            })

            formInfoRef.setFieldsValue({
                actual_pay_amount: num
            })
        }
    }, [payNums])

    const handlePayNumChange = (e: any, attr: number) => {
        let r: any = _.cloneDeep(payNums)
        r[attr] = e
        setPayNums(r)
    }

    const handleActualPay = (e: any) => {
        formInfoRef.setFieldsValue({ actual_pay_amount: e })
    }

    const handlePayTypeChange = (e: any) => {
        let num = 0

        e.forEach((el: any) => {
            num += ((Number(payNums[el]) * 100) / 100) || 0
        })

        formInfoRef.setFieldsValue({
            actual_pay_amount: num
        })
    }

    const handleSubmit = () => {

        if (!buyList.length && !giveList.length && !extraList.length) {
            message.warning('请至少选择一个套餐项目!')
            return false
        }

        if (buyList.length) {
            let falg = true

            buyList.map((el: any) => {
                if (el.chankang_item_type == '' || el.item_latest_price == '' || el.store_item_id == '' || el.total == 0 || el.total_amount == '' || !el.total_amount) {
                    falg = false
                }
            })

            if (!falg) {
                message.warning('请正确填写产康购买必填项!')
                return false
            }
        }

        if (giveList.length) {
            let falg = true

            giveList.map((el: any) => {
                if (el.chankang_item_type == '' || el.item_latest_price == '' || el.store_item_id == '') {
                    falg = false
                }
            })

            if (!falg) {
                message.warning('请完成产康赠送数据填写!')
                return false
            }
        }

        if (extraList.length) {
            let falg = true

            extraList.map((el: any) => {
                if (el.chankang_item_type == '' || el.item_latest_price == '' || el.store_item_id == '') {
                    falg = false
                }
            })

            if (!falg) {
                message.warning('请完成月子赠送数据填写!')
                return false
            }
        }

        if (formData2.length == 0 && formData.length == 0) {
            message.error('签单人选项，产康顾问和产康师最少要有一个!')
            return false
        }

        let data = {
            store_id: storeId,
            customer_id: id,
            employee_id_adviser: employeeIdAdviser,
            employee_id_recover: employeeIdRecover,
            buy_item_list: buyList.filter(item => item.store_item_id != ''),
            gift_chankang_item_list: giveList.filter(item => item.store_item_id != ''),
            gift_yuezi_item_list: extraList.filter(item => item.store_item_id != ''),
            order_date: '',
            actually_deal_amount: totalPrices,
            pay_records: [],
            pay_pic_list: '',
            deal_date: '',
            remark: formInfoRef.getFieldValue('remark'),
            employee_adviser_list: formData,
            employee_recover_list: formData2
        }

        if (buyList.length) {
            data.deal_date = formInfoRef.getFieldValue('deal_date').format('YYYY-MM-DD HH:mm:ss')

            // 处理支付方式
            if (formInfoRef.getFieldValue('pay_way')) {
                data.pay_records = formInfoRef.getFieldValue('pay_way').map((el: any) => {
                    return {
                        "pay_amount": payNums[el],
                        "pay_way": el
                    }
                })
            }
        }

        if (formInfoRef.getFieldValue('payList').length) {
            data.pay_pic_list = formInfoRef.getFieldValue('payList').map((item: any) => { return item.response.data[0] }).toString() || ''
        }

        axiosHandleEvent.post('/chankang_center/order_list/add', data).then(res => { })
    }

    useEffect(() => {
        // 查询门店
        baseAxiosNoInfo('/global/store_list').then((res: any) => {
            if (res) {
                setStoreId(res[0].store_id)
                // 初始化加载项目
                getStoreItemList(res[0].store_id, '', 1) // 产康单项
                getStoreItemList(res[0].store_id, '', 2) // 产康套餐

                setDefaultStoreName(res[0].store_name)
                setOptionData(res)

                getEmployeeList(res[0].store_id, 4)
                getEmployeeList(res[0].store_id, 5)

                baseAxiosNoInfo('/global/employee_list_by_position', {
                    params: {
                        position_number: 4,
                        department_id: res[0].store_id
                    }
                }).then((res: any) => {
                    setEmpList(res)
                })

                baseAxiosNoInfo('/global/employee_list_by_position', {
                    params: {
                        position_number: 5,
                        department_id: res[0].store_id
                    }
                }).then((res: any) => {
                    setEmpList2(res)
                })
            }
        })

        // 查询项目分类
        baseAxiosNoInfo('/chankang_center/item_type/select_list').then((res: any) => {
            if (res) {
                setCkType(res)
            }
        })
    }, [])

    // 某组织下的员工列表，产康师 产康顾问
    const getEmployeeList = (storeId: any, type: any) => {
        baseAxiosNoInfo('/global/employee_list_by_position', { params: { department_id: storeId, position_number: type } }).then((res: any) => {
            if (res) {
                if (type == 5) {
                    setEmpList2(res)
                } else {
                    setEmpList(res)
                }
            }
        })
    }

    const handleAddBuyList = (type: any) => {
        let data: any = [
            {
                chankang_item_type: undefined,
                item_latest_price: undefined,
                store_item_id: undefined,
                count: 1,
                total: 0
            }
        ]

        if (type == 'buy') {
            setBuyList([...buyList, ...data])
        }

        if (type == 'give') {
            setGiveList([...giveList, ...data])
        }

        if (type == "extra") {
            setExtraList([...extraList, ...data])
        }
    }

    const deleteBuyList = (index: any, which: any) => {
        if (which == 'buy') {
            let data = _.cloneDeep(buyList).filter((item: any, index1: any) => index1 !== index)
            setBuyList(data)
        }

        if (which == 'give') {
            let data = _.cloneDeep(giveList).filter((item: any, index1: any) => index1 !== index)
            setGiveList(data)
        }

        if (which == 'extra') {
            let data = _.cloneDeep(extraList).filter((item: any, index1: any) => index1 !== index)
            setExtraList(data)
        }
    }

    // 选择门店
    const handleStore = (value: any, option: any) => {
        setDefaultStoreName(option.children)
        setStoreId(value)

        getStoreItemList(value, '', 1) // 产康单项
        getStoreItemList(value, '', 2) // 产康套餐

        getEmployeeList(value, 4) // 产康顾问
        getEmployeeList(value, 5) // 产康师
    }

    // 金额输入框小数点控制后两位
    const limitDecimals = (value: any) => {
        const reg = /^(\-)*(\d+)\.(\d\d).*$/;
        // 取数字
        const data = value.replace(/[^0-9.]/g, "")

        // 取小数点后两位
        return data.replace(reg, '$1$2.$3')
    }

    // 切换项目类型
    const handleSelectProject = (el: any, index: any, type: any, which: any) => {
        if (which == 'buy') {
            let newArr = _.cloneDeep(buyList)
            newArr[index][type] = el
            newArr[index]['item_type_id'] = ''
            newArr[index]['store_item_id'] = ''
            setBuyList(newArr)
        }

        if (which == 'give') {
            let newArr = _.cloneDeep(giveList)
            newArr[index][type] = el
            newArr[index]['item_type_id'] = ''
            newArr[index]['store_item_id'] = ''
            setGiveList(newArr)
        }

        if (which == 'extra') {
            let newArr = _.cloneDeep(extraList)
            newArr[index][type] = el
            newArr[index]['item_type_id'] = ''
            newArr[index]['store_item_id'] = ''
            setExtraList(newArr)
        }

        if (type == 'chankang_item_type' && el == '1') {
            setCkSingle(ckTypeItem)
        }
    }

    // 选择套餐
    const handleSelectStore = (el: any, index: any, option: any, type: any, which: any) => {
        if (which == 'buy') {
            let newArr = _.cloneDeep(buyList)
            newArr[index][type] = el
            newArr[index]['item_id'] = option.tab
            newArr[index]['total'] = option.label
            newArr[index]['item_latest_price'] = option.label
            setBuyList(newArr)
        }

        if (which == 'give') {
            let newArr = _.cloneDeep(giveList)
            newArr[index][type] = el
            newArr[index]['item_id'] = option.tab
            newArr[index]['item_latest_price'] = option.label
            setGiveList(newArr)
        }

        if (which == 'extra') {
            let newArr = _.cloneDeep(extraList)
            newArr[index][type] = el
            newArr[index]['item_id'] = option.tab
            newArr[index]['item_latest_price'] = option.label
            setExtraList(newArr)
        }

        if (type == 'item_type_id') {
            getStoreItemList(storeId, option.type_key, 1)
        }
    }

    // 处理次数
    const handleCount = (el: any, index: any, type: any, which: any) => {

        if (which == 'buy') {
            let newArr = _.cloneDeep(buyList)

            if (type == 'total_amount') {
                newArr[index][type] = el.target.value
                // 计算订单总价
            } else {
                newArr[index][type] = el
            }

            newArr[index]['total'] = newArr[index]['item_latest_price'] * newArr[index]['count']

            setBuyList(newArr)
        }

        if (which == 'give') {
            let newArr = _.cloneDeep(giveList)
            newArr[index][type] = el
            newArr[index]['total'] = newArr[index]['item_latest_price'] * newArr[index]['count']

            setGiveList(newArr)
        }

        if (which == 'extra') {
            let newArr = _.cloneDeep(extraList)
            newArr[index][type] = el
            newArr[index]['total'] = newArr[index]['item_latest_price'] * newArr[index]['count']

            setExtraList(newArr)
        }
    }

    // 查看套餐项目
    const queryPackageItem = (value: string) => {
        baseAxiosNoInfo('/chankang_center/item_package/detail', {
            params: {
                item_id: value
            }

        }).then((res: any) => {
            res && setPackageItemData(res.item_attribute_base)
        })

        setPackageItemVisible(true)
    }

    // 查询门店项目列表
    const getStoreItemList = (value: any, typeId: any, type: any) => {
        baseAxiosNoInfo('/chankang_center/store_item/on_list', {
            params: {
                store_id: value,
                item_type_id: typeId,
                chankang_item_type: type
            }
        }).then((res: any) => {
            if (res) {
                if (type == 1) {
                    setCkSingle(res)

                    if (typeId == '') {
                        setCkTypeItem(res)
                    }
                }

                if (type == 2) {
                    setCkMenu(res)
                }
            }
        })
    }

    // 监听订单总价
    useEffect(() => {
        let prices = 0

        for (let i = 0; i < buyList.length; i++) {
            // prices += (buyList[i].count * buyList[i].total_amount)
            prices += parseFloat(buyList[i].total_amount)
        }

        let money: any = prices.toFixed(2)
        setTotalPrices(isNaN(money) ? 0 : money)
    }, [totalPrices, buyList])

    const [empList, setEmpList] = useState<any[]>([])
    const [empList2, setEmpList2] = useState<any[]>([])

    const storeList = optionData.map((el: any) => (<Option value={el.store_id} key={el.store_id} >{el.store_name}</Option>))

    const getckTypeList = ckType.map((el: any) => (<Option value={el.item_type_id} type_key={el.item_type_id} >{el.item_type_name}</Option>))
    const getckSingleList = ckSingle.map((el: any) => (<Option value={el.store_item_id} key={el.store_item_id} tab={el.item_id} label={el.item_latest_price} >{el.store_item_name}</Option>))
    const getckMenuList = ckMenu.map((el: any) => (<Option value={el.store_item_id} key={el.store_item_id} tab={el.item_id} label={el.item_latest_price} >{el.store_item_name}</Option>))

    interface formRow {
        employee_id: string | undefined
        user_name: string | undefined
        results_proportion: number | undefined
    }

    let formRow: formRow = {
        employee_id: undefined,
        user_name: undefined,
        results_proportion: undefined
    }

    const [formData, setFormData] = useState<formRow[]>([])
    const [formData2, setFormData2] = useState<formRow[]>([])

    const addMoreRow = () => {
        setFormData([...formData, formRow])
    }

    const addMoreRow2 = () => {
        setFormData2([...formData2, formRow])
    }

    const deleteRow = (index: number) => {
        let reciveD = _.cloneDeep(formData)
        reciveD.splice(index, 1)

        setFormData(reciveD)
    }

    const deleteRow2 = (index: number) => {
        let reciveD = _.cloneDeep(formData2)
        reciveD.splice(index, 1)

        setFormData2(reciveD)
    }

    const handleChange = (index: number, attr: string, value: any) => {
        let reciveD: any = _.cloneDeep(formData)
        reciveD[index][attr] = value

        if (attr == 'employee_id') {
            empList.forEach(el => {
                if (el.employee_id == value) {
                    reciveD[index]['user_name'] = el.user_name
                }
            })
        }

        setFormData(reciveD)
    }

    const handleChange2 = (index: number, attr: string, value: any) => {
        let reciveD: any = _.cloneDeep(formData2)
        reciveD[index][attr] = value

        if (attr == 'employee_id') {
            empList2.forEach(el => {
                if (el.employee_id == value) {
                    reciveD[index]['user_name'] = el.user_name
                }
            })
        }

        setFormData2(reciveD)
    }

    return (<div className="ck-order-list-add common-level2-edit">
        {/* 产康中心 -> 产康客户管理 -> 产康客户列表 -> 客户详情 -> 录入订单 */}
        <div className="sections">
            <h2>录入订单</h2>

            <div className="sections-content">
                <div className="common-main">
                    <Form {...formItemLayout} form={vipInfoRef}>
                        <Form.Item label="门店" required>
                            <Select style={{ width: 200 }} placeholder="选择门店" onChange={handleStore} value={defaultStoreName}>{storeList}</Select>
                        </Form.Item>

                        <Form.Item label="签单人" required wrapperCol={{ span: 10 }}>
                            <div className='employee_box2'>
                                {formData.map((el, index: number) =>
                                    <Row gutter={8} justify="space-between" style={{ marginBottom: 8, userSelect: 'none', maxWidth: 600 }}>
                                        <Col span={10}>
                                            <Select placeholder="产康顾问" style={{ width: '100%' }} onChange={(v: any) => {
                                                handleChange(index, 'employee_id', v)
                                            }}>
                                                {empList.map((el) => <Option value={el.employee_id}>{el.user_name}</Option>)}
                                            </Select>
                                        </Col>

                                        <Col span={10}>
                                            <Input placeholder='分配比例' style={{ width: '100%' }} value={el.results_proportion} type="number" onChange={(v: any) => {
                                                handleChange(index, 'results_proportion', v.target.value)
                                            }} />
                                        </Col>

                                        <Col span={4} style={{ paddingTop: 4 }}>
                                            <DeleteOutlined onClick={() => {
                                                deleteRow(index)
                                            }} style={{ cursor: 'pointer' }} />
                                        </Col>
                                    </Row>)
                                }

                                <Button onClick={addMoreRow} style={{ marginTop: 16 }} size="small" type="primary">添加产康顾问</Button>

                                <div className="line" style={{ marginTop: 20, marginBottom: 20, width: '100%', border: '1px dashed #999', height: 0 }}></div>

                                {formData2.map((el, index: number) =>
                                    <Row gutter={8} justify="space-between" style={{ marginBottom: 8, userSelect: 'none', maxWidth: 600 }}>
                                        <Col span={10}>
                                            <Select placeholder="产康师" style={{ width: '100%' }} onChange={(v: any) => {
                                                handleChange2(index, 'employee_id', v)
                                            }}>
                                                {empList2.map((el) => <Option value={el.employee_id}>{el.user_name}</Option>)}
                                            </Select>
                                        </Col>

                                        <Col span={10}>
                                            <Input placeholder='分配比例' style={{ width: '100%' }} value={el.results_proportion} type="number" onChange={(v: any) => {
                                                handleChange2(index, 'results_proportion', v.target.value)
                                            }} />
                                        </Col>

                                        <Col span={4} style={{ paddingTop: 4 }}>
                                            <DeleteOutlined onClick={() => {
                                                deleteRow2(index)
                                            }} style={{ cursor: 'pointer' }} />
                                        </Col>
                                    </Row>)}

                                <Button onClick={addMoreRow2} style={{ marginTop: 16 }} size="small" type="primary">添加产康师</Button>

                                <div style={{ marginTop: 20 }}><span style={{ color: 'red' }}>注*</span> 产康顾问、产康师，必须选择其一或全选！</div>
                            </div>
                        </Form.Item>

                        <Form.Item label="客户姓名" name="customer_name">
                            {userData[0]?.customer_name ? userData[0]?.customer_name : '--'}
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </div>

        <div className="sections">
            <h2 style={{ display: 'flex', alignItems: 'center' }}>产康购买
                <div style={{ fontSize: '24', color: '#1890ff', paddingLeft: '20px', cursor: 'pointer' }} onClick={() => { handleAddBuyList('buy') }}>添加</div>
            </h2>
            <div style={{ paddingLeft: '50px', paddingBottom: '20px', display: buyList.length ? '' : 'none' }}>
                <Row gutter={0} className="title" style={{ marginBottom: '10px' }}>
                    <Col span="3"><span className='must'>项目类型</span></Col>
                    <Col span="4"><span className='must'>项目名称</span></Col>
                    <Col span="4">项目明细</Col>
                    <Col span="3"><span className='must'>项目单价</span></Col>
                    <Col span="3"><span className='must'>项目次数</span></Col>
                    <Col span="3"><span className='must'>金额(元)</span></Col>
                    <Col span="3">删除</Col>
                </Row>

                {buyList.map((el: any, index: number) => (
                    <Row key={index} style={{ height: '50px', lineHeight: '50px' }}>
                        <Col span="3">
                            <Select placeholder="选择类型" value={el.chankang_item_type} onChange={(el: any) => { handleSelectProject(el, index, 'chankang_item_type', 'buy') }}>
                                <Option value="1">产康单项</Option>
                                <Option value="2">产康套餐</Option>
                            </Select>
                        </Col>
                        <Col span="4">
                            {el.chankang_item_type == 1 && <Select style={{ minWidth: '160px' }}
                                showSearch placeholder="选择项目分类" value={el.item_type_id}
                                filterOption={(input, option) =>
                                    (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())
                                }
                                onChange={(el: any, option: any) => {
                                    handleSelectStore(el, index, option, 'item_type_id', 'buy')
                                }}
                            >
                                {getckTypeList}
                            </Select>}

                            {el.chankang_item_type == 2 && <Select style={{ minWidth: '160px' }}
                                showSearch placeholder="选择项目" value={el.store_item_id}
                                filterOption={(input, option) =>
                                    (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())
                                }
                                onChange={(el: any, option: any) => {
                                    handleSelectStore(el, index, option, 'store_item_id', 'buy')
                                }}
                            >
                                {getckMenuList}
                            </Select>}
                        </Col>
                        <Col span="4">
                            {el.chankang_item_type == 1 && <Select style={{ minWidth: '160px' }}
                                showSearch placeholder="选择项目" value={el.store_item_id}
                                filterOption={(input, option) =>
                                    (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())
                                }
                                onChange={(el: any, option: any) => {
                                    handleSelectStore(el, index, option, 'store_item_id', 'buy')
                                }}
                            >
                                {getckSingleList}
                            </Select>}

                            {el.chankang_item_type == 2 && <Button onClick={() => {
                                queryPackageItem(el.item_id)
                            }} size="small" >查看</Button>}
                        </Col>
                        <Col span="3"><Input disabled placeholder="项目单价" value={el.item_latest_price} style={{ width: 100 }} /></Col>
                        <Col span="3"><InputNumber min={1} max={50} placeholder="项目次数" value={el.count} onChange={(el: any) => { handleCount(el, index, 'count', 'buy') }} /></Col>
                        <Col span="3" ><Input placeholder="金额" value={el.total_amount} style={{ width: 100 }} onChange={(el: any) => { handleCount(el, index, 'total_amount', 'buy') }} /></Col>
                        <Col span="3"><DeleteOutlined style={{ cursor: 'pointer', color: 'red' }} onClick={() => { deleteBuyList(index, 'buy') }} /></Col>
                    </Row>
                ))}
            </div>
        </div>

        <div className="sections">
            <h2 style={{ display: 'flex', alignItems: 'center' }}>产康赠送
                <div style={{ fontSize: '24', color: '#1890ff', paddingLeft: '20px', cursor: 'pointer' }} onClick={() => { handleAddBuyList('give') }}>添加</div>
            </h2>
            <div style={{ paddingLeft: '50px', paddingBottom: '20px', display: giveList.length ? '' : 'none' }}>
                <Row gutter={0} className="title" style={{ marginBottom: '10px' }}>
                    <Col span="3"><span className='must'>项目类型</span></Col>
                    <Col span="4"><span className='must'>项目名称</span></Col>
                    <Col span="4">项目明细</Col>
                    <Col span="3"><span className='must'>项目单价</span></Col>
                    <Col span="3"><span className='must'>项目次数</span></Col>
                    <Col span="3">删除</Col>
                </Row>

                {giveList.map((el: any, index: number) => (
                    <Row key={index} style={{ height: '50px', lineHeight: '50px' }}>
                        <Col span="3">
                            <Select style={{ width: 120 }} placeholder="选择类型" value={el.chankang_item_type} onChange={(el: any) => { handleSelectProject(el, index, 'chankang_item_type', 'give') }}>
                                <Option value="1">产康单项</Option>
                                <Option value="2">产康套餐</Option>
                            </Select>
                        </Col>
                        <Col span="4">
                            {el.chankang_item_type == 1 && <Select style={{ minWidth: '160px' }}
                                showSearch placeholder="选择项目分类" value={el.item_type_id}
                                filterOption={(input, option) =>
                                    (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())
                                }
                                onChange={(el: any, option: any) => {
                                    handleSelectStore(el, index, option, 'item_type_id', 'give')
                                }}
                            >
                                {getckTypeList}
                            </Select>}

                            {el.chankang_item_type == 2 && <Select style={{ minWidth: '160px' }}
                                showSearch placeholder="选择项目" value={el.store_item_id}
                                filterOption={(input, option) =>
                                    (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())
                                }
                                onChange={(el: any, option: any) => {
                                    handleSelectStore(el, index, option, 'store_item_id', 'give')
                                }}
                            >
                                {getckMenuList}
                            </Select>}
                        </Col>
                        <Col span="4">
                            {el.chankang_item_type == 1 && <Select style={{ minWidth: '160px' }}
                                showSearch placeholder="选择项目" value={el.store_item_id}
                                filterOption={(input, option) =>
                                    (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())
                                }
                                onChange={(el: any, option: any) => {
                                    handleSelectStore(el, index, option, 'store_item_id', 'give')
                                }}
                            >
                                {getckSingleList}
                            </Select>}

                            {el.chankang_item_type == 2 && <Button onClick={() => {
                                queryPackageItem(el.item_id)
                            }} size="small" >查看</Button>}
                        </Col>
                        <Col span="3"><Input disabled placeholder="项目单价" value={el.item_latest_price} style={{ width: 100 }} /></Col>
                        <Col span="3"><InputNumber min={1} max={50} placeholder="项目次数" value={el.count} onChange={(el: any) => { handleCount(el, index, 'count', 'give') }} /></Col>
                        <Col span="3"><DeleteOutlined style={{ cursor: 'pointer', color: 'red' }} onClick={() => { deleteBuyList(index, 'give') }} /></Col>
                    </Row>
                ))}
            </div>
        </div>

        <div className="sections">
            <h2 style={{ display: 'flex', alignItems: 'center' }}>月子赠送
                <div style={{ fontSize: '24', color: '#1890ff', paddingLeft: '20px', cursor: 'pointer' }} onClick={() => { handleAddBuyList('extra') }}>添加</div>
            </h2>
            <div style={{ paddingLeft: '50px', paddingBottom: '20px', display: extraList.length ? '' : 'none' }}>
                <Row gutter={0} className="title" style={{ marginBottom: '10px' }}>
                    <Col span="3"><span className='must'>项目类型</span></Col>
                    <Col span="4"><span className='must'>项目名称</span></Col>
                    <Col span="4">项目明细</Col>
                    <Col span="3"><span className='must'>项目单价</span></Col>
                    <Col span="3"><span className='must'>项目次数</span></Col>
                    <Col span="3">删除</Col>
                </Row>

                {extraList.map((el: any, index: number) => (
                    <Row key={index} style={{ height: '50px', lineHeight: '50px' }}>
                        <Col span="3">
                            <Select style={{ width: 120 }} placeholder="选择类型" value={el.chankang_item_type} onChange={(el: any) => { handleSelectProject(el, index, 'chankang_item_type', 'extra') }}>
                                <Option value="1">产康单项</Option>
                                <Option value="2">产康套餐</Option>
                            </Select>
                        </Col>
                        <Col span="4">
                            {el.chankang_item_type == 1 && <Select style={{ minWidth: '160px' }}
                                showSearch placeholder="选择项目分类" value={el.item_type_id}
                                filterOption={(input, option) =>
                                    (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())
                                }
                                onChange={(el: any, option: any) => {
                                    handleSelectStore(el, index, option, 'item_type_id', 'extra')
                                }}
                            >
                                {getckTypeList}
                            </Select>}

                            {el.chankang_item_type == 2 && <Select style={{ minWidth: '160px' }}
                                showSearch placeholder="选择项目" value={el.store_item_id}
                                filterOption={(input, option) =>
                                    (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())
                                }
                                onChange={(el: any, option: any) => {
                                    handleSelectStore(el, index, option, 'store_item_id', 'extra')
                                }}
                            >
                                {getckMenuList}
                            </Select>}
                        </Col>
                        <Col span="4">
                            {el.chankang_item_type == 1 && <Select style={{ minWidth: '160px' }}
                                showSearch placeholder="选择项目" value={el.store_item_id}
                                filterOption={(input, option) =>
                                    (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())
                                }
                                onChange={(el: any, option: any) => {
                                    handleSelectStore(el, index, option, 'store_item_id', 'extra')
                                }}
                            >
                                {getckSingleList}
                            </Select>}

                            {el.chankang_item_type == 2 && <Button onClick={() => {
                                queryPackageItem(el.item_id)
                            }} size="small" >查看</Button>}
                        </Col>
                        <Col span="3"><Input disabled placeholder="项目单价" value={el.item_latest_price} style={{ width: 100 }} /></Col>
                        <Col span="3"><InputNumber min={1} max={50} placeholder="项目次数" value={el.count} onChange={(el: any) => { handleCount(el, index, 'count', 'extra') }} /></Col>
                        <Col span="3"><DeleteOutlined style={{ cursor: 'pointer', color: 'red' }} onClick={() => { deleteBuyList(index, 'extra') }} /></Col>
                    </Row>
                ))}
            </div>
        </div>

        <div className="sections" style={{ display: buyList.length ? '' : 'none' }}>
            <h2>订单结算</h2>
            <div className="sections-content">
                <Form labelCol={{ span: 3 }} wrapperCol={{ span: 3 }} form={formRef}>
                    <Form.Item label="订单金额" >
                        <Input placeholder="" disabled value={totalPrices} />
                    </Form.Item>
                    <Form.Item label="成交金额" required>
                        <InputNumber style={{ width: '100%' }} disabled value={totalPrices} onChange={((el: any) => { setShouldPay(el) })} formatter={limitDecimals} placeholder="请填写成交金额" />
                    </Form.Item>
                </Form>
            </div>
        </div>

        <div className="sections" >
            <h2>付款信息</h2>
            <div className="sections-content">
                <Form labelCol={{ span: 3 }} wrapperCol={{ span: 20 }} form={formInfoRef} onFinish={handleSubmit}>
                    <Form.Item label="下单时间" name="order_date" rules={[{ required: true, message: '必须选择下单时间' }]}>
                        <DatePicker placeholder="选择下单时间" style={{ width: 200 }} />
                    </Form.Item>

                    {buyList.length != 0 && <Form.Item label="付款方式" name="pay_way" rules={[{ required: true, message: '必须选择付款方式' }]}>
                        <Checkbox.Group onChange={handlePayTypeChange} >
                            <Checkbox value={3} style={{ marginTop: 5 }}><Space><img src={wx} />微信<InputNumber type="number" style={{ width: 110 }} value={payNums['3']} onChange={(e: any) => { handlePayNumChange(e, 3) }} formatter={limitDecimals} /></Space></Checkbox>
                            <Checkbox value={2} style={{ marginTop: 5 }}><Space><img src={zfb} />支付宝<InputNumber type="number" style={{ width: 110 }} value={payNums['2']} onChange={(e: any) => { handlePayNumChange(e, 2) }} formatter={limitDecimals} /></Space></Checkbox>
                            <Checkbox value={4} style={{ marginTop: 5 }}><Space><img src={money} />POS机<InputNumber type="number" style={{ width: 110 }} value={payNums['4']} onChange={(e: any) => { handlePayNumChange(e, 4) }} formatter={limitDecimals} /></Space></Checkbox>
                            <Checkbox value={1} style={{ marginTop: 5 }}><Space><img src={pos} />现金<InputNumber type="number" style={{ width: 110 }} value={payNums['1']} onChange={(e: any) => { handlePayNumChange(e, 1) }} formatter={limitDecimals} /></Space></Checkbox>
                            <Checkbox value={5} style={{ marginTop: 5 }}><Space>月子转入<InputNumber type="number" style={{ width: 110 }} value={payNums['5']} onChange={(e: any) => { handlePayNumChange(e, 5) }} formatter={limitDecimals} /></Space></Checkbox>
                        </Checkbox.Group>
                    </Form.Item>}

                    {buyList.length != 0 && <Form.Item label="付款金额" name="actual_pay_amount">
                        <InputNumber placeholder="请输入付款金额" onChange={(e: any) => { handleActualPay(e) }} style={{ width: 200 }} formatter={limitDecimals} disabled />
                    </Form.Item>}

                    {buyList.length != 0 && <Form.Item label="付款时间" name="deal_date" rules={[{ required: true, message: '必须选择付款时间' }]}>
                        <DatePicker placeholder="请选择付款时间" style={{ width: 200 }} />
                    </Form.Item>}

                    <Form.Item
                        label="收款凭证"
                        valuePropName="fileList"
                        getValueFromEvent={uploadFile}
                        name="payList"
                        extra="（最多可上传6张，大小不超过2M）"
                        rules={[{ required: true, message: '必须上传图片' }]}
                    >
                        <Upload
                            name="files"
                            onPreview={handlePreview}
                            data={{ fileType: 1, bucketType: 4 }}
                            action={apiPrefix + '/global/upload_pic'}
                            listType="picture-card"
                            fileList={payList}
                        >
                            {uploadButton}
                        </Upload>
                    </Form.Item>

                    <Form.Item label="备注" name="remark">
                        <Input.TextArea placeholder="" />
                    </Form.Item>

                    <Form.Item wrapperCol={{ offset: 3 }}>
                        <Space>
                            <Button type="primary" htmlType="submit">提交</Button>
                            <Button onClick={() => { window.history.go(-1) }} >返回</Button>
                        </Space>
                    </Form.Item>
                </Form>
            </div>
        </div>

        {/* 项目明细弹窗 */}
        <Modal title="项目明细" visible={packageItemVisible} footer={false} onCancel={() => { setPackageItemVisible(false) }} width={500}>
            <div style={{ margin: '5px' }}>
                <Table pagination={false} dataSource={packageItemData} scroll={{ x: 'max-content' }} bordered={true} rowKey="id">
                    <Column title="项目名称" dataIndex="item_name" key="item_name" />
                    <Column title="项目次数" dataIndex="standard_times" key="standard_times" />
                </Table>
            </div>
        </Modal>

        <Modal visible={visible} title='浏览图片' footer={null} onCancel={() => { setVisible(false) }} >
            <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>
    </div>)
}